import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      waiver, // via withQuery
      setWaiverFormField // via withRedux
    } = props

    const { waiverType } = waiver

    // must accept fieldName for compatibility with FormTextFieldWithValidation
    const handleChangeFormField = fieldName => event => {
      const fieldValue = event.target.value
      setWaiverFormField({ waiverType, fieldName, fieldValue })
    }

    const handleChangeConsent = event => {
      const fieldName = 'consent'
      const fieldValue = event.target.value === 'true'
      setWaiverFormField({ waiverType, fieldName, fieldValue })
    }

    return (
      <WrappedComponent
        onChangeConsent={handleChangeConsent}
        onChangeFormField={handleChangeFormField}
        {...props}
      />
    )
  }
}

export default withEventHandlers
